import { useGoogleOneTapLogin } from "@react-oauth/google"
import { useNavigate } from "react-router-dom"
import { useAuth } from "@/context/auth/auth-context"
import hive from "@/lib/api/hive"

/**
 * Renderless component that shows the Google One Tap prompt for unauthenticated users.
 * Place on pages where you want to capture passive sign-ins (landing, auth pages).
 * Does nothing when the user is already authenticated.
 */
export function GoogleOneTap() {
	const { isAuthenticated, login } = useAuth()
	const navigate = useNavigate()

	useGoogleOneTapLogin({
		disabled: isAuthenticated,
		onSuccess: async (response) => {
			try {
				const tokens = await hive.socialLogin("google", response.credential!)
				await login(tokens, tokens.is_new_user)
				navigate("/dashboard", { replace: true })
			} catch {
				// One Tap failures are silent — user can still sign in via the button
			}
		},
		onError: () => {
			// Silent: One Tap errors shouldn't disrupt the page
		},
	})

	return null
}
